import useCanViewAdminConsole from "@/admin/hooks/useCanViewAdminConsole";
import BaseLayout from "@/base";
import NotAllowedError from "@/errors/NotAllowedError";
import NotLoggedInError from "@/errors/NotLoggedInError";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const withAdminPrivileges = (ComponentToWrap) => {
  const WrappedWithApprovedAdmin = () => {
    const { data: user } = useUser();
    const { isAuthenticatedUser } = getUserProperties(user);
    const hasAccessToAdminConsole = useCanViewAdminConsole();

    if (!isAuthenticatedUser)
      return <BaseLayout mainContents={<NotLoggedInError />} />;
    if (hasAccessToAdminConsole) return <ComponentToWrap />;
    return <BaseLayout mainContents={<NotAllowedError />} />;
  };

  return WrappedWithApprovedAdmin;
};

export default withAdminPrivileges;
